import React from "react";
import Carousel from "./Carousel";

export default function CarouselSection(props) {
  return (
    <div className="w-full">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          🎠 DeepDocs AI Features
        </h3>
        <p className="text-gray-600">
          Explore our powerful features through an interactive carousel experience
        </p>
      </div>
      
      <Carousel slides={props.carousel_slides} />
      
      <div className="mt-8 text-center">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 inline-block">
          <p className="text-blue-800 text-sm">
            <strong>React Component:</strong> This carousel is fully interactive with auto-play, navigation controls, and smooth transitions.
          </p>
        </div>
      </div>
    </div>
  );
}
